(ns portfolio.i18n
  "Translation helper. Content values that need localisation are stored as
  maps `{:en \"...\" :pt \"...\"}`. `tr` returns the version for the
  currently-active language; English is the fallback if a translation is
  missing. Plain strings (anything not a map) are returned as-is, which
  lets the content layer mix translatable and language-agnostic values
  in the same data structures."
  (:require [re-frame.core :as rf]
            [portfolio.subs :as subs]))

(def supported-langs [:en :pt])

(def lang-labels
  {:en "EN" :pt "PT"})

(defn tr
  "Return the value of `m` in the currently-active language, falling back to
  English. If `m` is not a map, returns it unchanged."
  [m]
  (if (map? m)
    (let [lang @(rf/subscribe [::subs/lang])]
      (or (get m lang) (get m :en) ""))
    m))
